/**
 * Header da impostare sulle richieste HTTP che non devono attivare il loader
 * bloccante a pagina intera gestito da LoadingStore/loaderInterceptor.
 */
export const SKIP_LOADER_HEADER = 'skip-loader';
